import {statusAndResponse} from "../../../util/requestHandler";
import {Api, decryptApiResponse} from "../../../config/Api";
import {getDateAsString} from "../../../util/date";

export function getClaims(params) {
  if (params.startDate) {
    params.startDate = getDateAsString(params.startDate, 'MM/DD/yyyy', 'yyyy-MM-DD')
  }

  if (params.endDate) {
    params.endDate = getDateAsString(params.endDate, 'MM/DD/yyyy', 'yyyy-MM-DD')
  }

  return statusAndResponse(
    Api.get(`/api/preliveDental`, {params}),
    decryptApiResponse
  )
}